import TweenMax from "gsap";
import React from "react";
import { computeControlPoints, strArc } from "./svg_utils";
import { DimensionsHandler } from "./withDimensions";

const debug = false;
const shift = 5;
const delta = 5;

type BubbleCircleProps = {
  color?: string;
  withoutBubbleAnimation?: boolean;
};

class BubbleCircle extends React.PureComponent<any, BubbleCircleProps> {
  prevScroll = { x: 0, y: 0 };
  clientRect = {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    width: 0,
    height: 0,
  };
  parallaxing = 0;

  up: number = 0;
  srcPoints: number[][];
  points: number[][];
  path: string;
  inside: boolean;
  color: string;
  dimensionsHandler: any;
  resizeTimer?: NodeJS.Timer = undefined;

  constructor(props: BubbleCircleProps) {
    super(props);

    this.srcPoints = this.createCirclePoints();
    this.points = this.srcPoints;
    this.path = this.createPath();
    this.inside = true;

    // Color
    this.color = props.color || "#efefef";
  }

  createPath() {
    let strPath = "";
    strPath += `M${this.points[0][0]},${this.points[0][1]}`;
    if (false) {
      for (var c = 0; c < this.points.length; c++) {
        strPath += `L${this.points[c][0]},${this.points[c][1]}`;
      }
      return strPath;
    }

    var px = computeControlPoints(this.points, 0);
    var py = computeControlPoints(this.points, 1);
    for (var c = 0; c < px.p1.length - 1; c++) {
      strPath += strArc(
        this.points[c][0],
        this.points[c][1],
        px.p1[c],
        py.p1[c],
        px.p2[c],
        py.p2[c],
        // c === px.p1.length - 1 ? pointLeft[0] : this.points[c + 1][0],
        // c === px.p1.length - 1 ? pointLeft[1] : this.points[c + 1][1]
        this.points[(c + 1) % this.points.length][0],
        this.points[(c + 1) % this.points.length][1]
      );
    }

    return strPath;
  }

  componentDidMount() {
    if (this.props.withoutBubbleAnimation) return;

    setTimeout(this.computeBounds, 50);
    setTimeout(this.computeBounds, 1000); // nav back layout fix
    setTimeout(this.computeBounds, 2000); // nav back layout fix

    this.dimensionsHandler = new DimensionsHandler({
      callback: () => {
        if (this.resizeTimer) clearTimeout(this.resizeTimer);
        this.resizeTimer = setTimeout(this.computeBounds, 500);
      },
    });
    this.dimensionsHandler.mount();

    window.addEventListener("mousemove", this.onMouseMove);
  }

  componentWillUnmount() {
    if (this.props.withoutBubbleAnimation) return;

    this.dimensionsHandler.unmount();
    window.removeEventListener("mousemove", this.onMouseMove);
  }

  createCirclePoints() {
    const points = [];
    const nPoints = 8; // 6+ is perfect | 5 almost a circle

    // for (var c = 0; c < nPoints + 1; c++) {
    for (var c = -1; c < nPoints + 2; c++) {
      //let degrees = startDegree + (360 - startDegree * 2) / (nPoints - 1) * c;
      let degrees = (360 / nPoints) * c;
      let radians = (degrees * Math.PI) / 180;

      let x = 50 + (50 - delta * 1.12) * Math.sin(radians);
      let y = 50 + (50 - delta * 1.12) * Math.cos(radians);

      points.push([x, y]);
    }
    return points; //[...points, [points[0][0], points[0][1]]];
  }

  computeBounds = () => {
    if (
      this.refs &&
      this.refs.container &&
      (this.refs.container as any).getBoundingClientRect
    ) {
      this.clientRect = (this.refs.container as any).getBoundingClientRect();
      this.prevScroll = {
        x: (typeof window !== `undefined` && window.pageXOffset) || 0,
        y: (typeof window !== `undefined` && window.pageYOffset) || 0,
      };

      //@ts-ignore
      if (debug) this.setState({ up: Date.now() });
    }
  };

  minMouseDelay = 50;
  postMousePointFunction: any;
  lastMouseUpdate: any;

  postMouseMove = (mousePoint: any) => {
    if (this.postMousePointFunction) {
      clearTimeout(this.postMousePointFunction);
      this.postMousePointFunction = undefined;
    }
    this.postMousePointFunction = setTimeout(() => {
      this.computeMouseOver(mousePoint);
    }, this.minMouseDelay + 10);
  };

  onMouseMove = (event: any) => {
    if (!this.clientRect) return;

    // const scale = (offset.right - offset.left) / 100;
    const size = Math.min(this.clientRect.width, this.clientRect.height);
    const scale = size / 100;
    // const scale = (this.clientRect.right - this.clientRect.left) / 100;

    const dx = (this.clientRect.width - size) / 2;
    const dy = (this.clientRect.height - size) / 2;

    const mousePoint = [
      // (event.pageX - this.clientRect.left - this.prevScroll.x) / scale,
      (event.pageX - this.clientRect.left - this.prevScroll.x - dx) / scale,
      (event.pageY - this.clientRect.top - this.prevScroll.y - dy) / scale,
    ];

    const millis = Date.now();
    if (
      this.lastMouseUpdate &&
      millis - this.lastMouseUpdate < this.minMouseDelay
    ) {
      this.postMouseMove(mousePoint);
      return; //wip - millis skip
    }
    this.lastMouseUpdate = millis;

    // this.computeMouseOver(mousePoint);
    setTimeout(() => this.computeMouseOver(mousePoint), 1);
  };

  computeMouseOver(mousePoint: any) {
    const width = this.clientRect.right - this.clientRect.left;

    // const centerPoint = this.centerPoint;
    // const centerPoint = [width / 2, width / 2];
    const centerPoint = [50, 50];

    //let radius = Math.min(centerPoint[0], centerPoint[1]) / 2;
    let radius = Math.min(centerPoint[0], centerPoint[1]);

    function parabolEase(x: number) {
      var y = 2 * x * x;
      if (x > 0.5) {
        x -= 1;
        y = -2 * x * x + 1;
      }
      return y;
    }

    // mouse - center
    let mcdx = mousePoint[0] - centerPoint[0];
    let mcdy = mousePoint[1] - centerPoint[1];
    let mcd = Math.sqrt(mcdx * mcdx + mcdy * mcdy);

    const newPoints = [];
    for (let c = 0; c < this.srcPoints.length; c++) {
      /// DISTANCES

      // mouse - point
      let mpdx = this.srcPoints[c][0] - mousePoint[0];
      let mpdy = this.srcPoints[c][1] - mousePoint[1];
      let mpd = Math.sqrt(mpdx * mpdx + mpdy * mpdy);

      // point - center
      let pcdx = this.srcPoints[c][0] - centerPoint[0];
      let pcdy = this.srcPoints[c][1] - centerPoint[1];
      let pcd = Math.sqrt(pcdx * pcdx + pcdy * pcdy);

      if (mpd < radius) {
        let prog = 1 - mpd / radius;

        prog = parabolEase(prog);

        let ratio = delta / pcd;
        let dx = ratio * mcdx;
        let dy = ratio * mcdy;

        newPoints[c] = [
          this.srcPoints[c][0] + prog * dx,
          this.srcPoints[c][1] + prog * dy,
        ];
      } else {
        newPoints[c] = this.srcPoints[c];
      }
    }

    this.points = newPoints;

    //!wip to remove
    // this.points[0] = mousePoint;

    const newPath = this.createPath();

    if (this.refs.path && newPath != this.path) {
      this.path = newPath;
      TweenMax.killTweensOf(this.refs.path);

      TweenMax.to(this.refs.path, 0.2, {
        attr: { d: this.path },
      });
    }
  }

  render() {
    const bgImageId = "background-img-" + (this.props.id || "cover");

    return (
      <div className="bubble">
        {/* <svg
          width={width + shift * 2}
          height={height}
          viewBox={`0 0 ${width} ${height}`}
          xmlns="http://www.w3.org/2000/svg"
          style={{
            position: "absolute",
            left: -shift,
            top: -shift,
            pointerEvents: "none",
            opacity: debug ? 0.5 : 1,
            background: debug ? "rgba(0, 0, 255, 0.8)" : null
          }}
        >
          <g transform={`translate(0 ${pix})`}>
            <path
              // id="path"
              ref="path"
              d={this.path}
              fill={debug ? "#ff00ff" : "#ffffff"}
              //fill="transparent"
              //stroke="#00ff00"
              //strokeWidth={2}
            />
          </g>
        </svg> */}

        <div
          ref="container"
          style={{
            position: "absolute",
            left: "-" + shift + "%",
            top: "-" + shift + "%",
            width: 100 + shift * 2 + "%",
            height: 100 + shift * 2 + "%",
            // background: debug ? "rgba(0, 0, 255, 0.1)" : undefined
          }}
        >
          <svg
            width="100%"
            height="100%"
            viewBox="0 0 100 100"
            // preserveAspectRatio="xMaxYMax meet"
          >
            {this.props.backgroundImage ? (
              <defs>
                <pattern
                  id={bgImageId}
                  // id="bg-img-circle"
                  patternUnits="userSpaceOnUse"
                  width="100"
                  height="100"
                >
                  <image
                    key={this.props.backgroundImage}
                    href={this.props.backgroundImage}
                    x="0"
                    y="0"
                    width="100"
                    height="100"
                  />
                </pattern>
              </defs>
            ) : null}

            {debug ? (
              <circle cx={50} cy={50} r={45.5} fill="rgba(255, 0, 0, 0.3" />
            ) : null}

            <path
              // id="path"
              ref="path"
              d={this.path}
              fill={
                debug
                  ? "none"
                  : this.props.backgroundImage
                  ? `url(#${bgImageId})`
                  : this.color
              } // #efefef
              stroke={debug ? "#ff00ff" : undefined}
              //fill="transparent"
              //stroke="#00ff00"
              //strokeWidth={2}
            />

            {/* <image
              width="50px"
              className="device"
              xlinkHref="/static/21f7ae67880d4711a6793ec3c1a1cf37/f3a49/marketing_analitics.png"
            /> */}
          </svg>
        </div>
      </div>
    );
  }
}

export default BubbleCircle;
